import './QuickLinks.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import React, { useState } from 'react';

const QuickLinks = () => {
  const [open, setOpen] = useState(false);
  const [internalReferenceOpen, setInternalReferenceOpen] = useState(false);
  const [externalReferenceOpen, setExternalReferenceOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="ql-container">
        <div className="ql-heading">QUICK LINKS</div>
        <div className="ql-content">
          <div className="entry-level">
            <div className="el-header">
              <div className="el-header-text">Entry Level</div>
              <img src={process.env.PUBLIC_URL + '/images/SAP/open-layers.svg'} alt="" className="el-header-icon" />
            </div>
            <div className="el-body">
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a href="https://atci.techexpressway.accenture.com/#code=0.AXsAOT154DkJbUmxKRmO3ZFv6yYZ0CVqjndBugqdm5yWBrt7AP0.AgABAAIAAAD--DLA3VO7QrddgJg7WevrAgDs_wQA9P8L3GAqlb8yy2SQababSbcaxpmss8DFf_mFdEghqjPXneS9xJLDj00Jq_HCQ8yM3CgX_jEzG4B4eMknq_rbECs9_f9Zgevhm9g7x9MNiLG9mXLNj2wi0hNKGwlJfEBrWAAOFvsjIu1WQcOOrxv9ltClN9vm4FiMFeL9vYQyomLR4GM8cibkhKtAnT4DLPTvOvc3akYz6fgaVAnmQ8QJI3511BmUVo3p5vybheMsTozErIFKrcOu-xl5J8I2n37E4JpXqn7uQlsZ0vlBzfA5EFmdE2wunQvBQOugAH_67LED-okjS46nTiQRQ3jQCHV2StOI3To4VRjcLMWtYVtC1LE0yHiLKzTQOxdAMTyJpt9vi90sGtp6MgcqdFWpnYEuDmVpih_9LZcJP9NQwjvHDF9QhaYjKkJPRMZZ0E7PKoDYJb1lhLeKOM7jbPFTlGUd8uDc8RWkTCljc5rpZVo69Bzr4SLRB6HtWGhlQybk4SgYPjqoBY7I4GYuRcGTV0BoDG1105b5DpZhC70FhIFvHWzQKNx4ydN6yc3-EEk6drJniZQwUA25M890jG7E2GGfzOgH4IB31_dWz1vXYckNjs4XERWdsW6ZMhZNNnennNBZ9hFv5f2zhK7konJroOz71KirA-AEyfmS5A1gS8Akr0B2X_Viwc5GN1QT8u3rGqVERK-gvb2qG8mYN6Y3VqDghtiH242dsZw2ue2Mp-JnBJW758opIQ09JuyHx3ISEWDjhd_oIWBVaL326Q4NQnVijH1qtBvfpVUVxZn5USRvnrchGdD75YpTy-8tbCaXwG8syT8j3Y04BIIAoUKCQd_jsYOQrM6bSF0kAxF1BvGHPXe_5XR_bkhoEUvDXsb49bUahKGjQAiwzQ6J3ApQTee27gm2QMtdOOW0IqaRDYWgpwQBBBi-zK_l562Zr3hXc2LuExZDPtMrS3ZTILRIMfcpu-BcRpGA2Vhfomsj7XTxweYHna1-SNrbKoNqUS3hQ2E04ipyv1EpNWSg_vaFz-RDs_KPYMG9Wqlj3BRBfhyDwvMTH-ZnS5amToLv7jxXc801SlWFSl_fKTbpwGQQuOp1J1Q_NbLW4klA1tfavT_YGf8&client_info=eyJ1aWQiOiIyOGM1M2U4NS1kNWEwLTQ2N2EtYjc4My00M2U2ODJkZWE5ZGEiLCJ1dGlkIjoiZTA3OTNkMzktMDkzOS00OTZkLWIxMjktMTk4ZWRkOTE2ZmViIn0&state=eyJpZCI6ImZiMGFhOTk3LTU4ZjItNDRiYi04ZjVlLWM3NmNjMjc0YmI1NyIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3d&session_state=8e8bd8a8-6d5b-4974-87d5-bf4d3ced84cc" target="_blank">
                    Tech Expressway
                  </a>
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a href="https://atci.techleap.accenture.com/techsegments/school/Advanced Oracle Application School for PLSQL" target="_blank">
                    Tech Leap
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="refrences">
            <div className="ref-header">
              <div className="ref-header-text">References</div>
              <img src={process.env.PUBLIC_URL + '/images/SAP/network.svg'} alt="" className="ref-header-icon" />
            </div>
            <div className="ref-body">
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <p
                    onClick={() => {
                      setInternalReferenceOpen(true);
                    }}
                    className="ql-references-text"
                  >
                    Internal References
                  </p>
                  <Modal open={internalReferenceOpen} onClose={() => setInternalReferenceOpen(false)}>
                    <div className="internal-references-box">
                      <div className="ascend_heading">
                        <h3 className="references-header">Internal References </h3>
                        <img
                          src={process.env.PUBLIC_URL + '/images/SAP/ql_close.png'}
                          onClick={() => setInternalReferenceOpen(false)}
                          className="references-close-btn"
                          alt=""
                        />
                      </div>
                      <div>
                        <div className="acend_points">
                          <div>
                            <img
                              src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                              alt="Arrow"
                              className="references-attachment-icon"
                            />
                            <a
                              href="https://connectedlearning.accenture.com/search/all/Oracle#bboards"
                              target="_blank"
                              rel="noreferrer"
                              className="ql-references-links"
                            >
                              Oracle Learning Boards
                            </a>
                          </div>
                          <div>
                            <img
                              src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                              alt="Arrow"
                              className="references-attachment-icon"
                            />
                            <a
                              href="https://accenture.percipio.com/search?q=Oracle"
                              target="_blank"
                              rel="noreferrer"
                              className="ql-references-links"
                            >
                              Accenture Percipio
                            </a>
                          </div>
                          <div>
                            <img
                              src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                              alt="Arrow"
                              className="references-attachment-icon"
                            />
                            <a
                              href="https://atci.lkm.accenture.com/LKM-eCatalog/Oracle-Flipbook"
                              target="_blank"
                              rel="noreferrer"
                              className="ql-references-links"
                            >
                              Oracle eCatalogs
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <p
                    onClick={() => {
                      setExternalReferenceOpen(true);
                    }}
                    className="ql-references-text"
                  >
                    External References
                  </p>
                  <Modal open={externalReferenceOpen} onClose={() => setExternalReferenceOpen(false)}>
                    <div className="external-references-box">
                      <div className="ascend_heading">
                        <h3 className="references-header">External References </h3>
                        <img
                          src={process.env.PUBLIC_URL + '/images/SAP/ql_close.png'}
                          onClick={() => setExternalReferenceOpen(false)}
                          className="references-close-btn"
                          alt=""
                        />
                      </div>
                      <div>
                        <div className="acend_points">
                          <div className="ql-external-references-1">
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://en.wikipedia.org/wiki/Oracle_Corporation"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle Wiki
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://mylearn.oracle.com/home"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle myLearn
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://mylearn.oracle.com/digital-library"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle Digital Library
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://blogs.oracle.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle Blogs
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://support.oracle.com/portal/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle Support
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://apexapps.oracle.com/pls/apex/f?p=44785:49:109994078760108"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle Learning Library
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://education.oracle.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle Training
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://docs.oracle.com/en/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle HelpCenter
                              </a>
                            </div>
                          </div>
                          <div className="ql-external-references-2">
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://www.oracle.com/in/index.html"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Oracle India
                              </a>
                            </div>                                                        
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
          <div className="special-programs">
            <div className="sp-header">
              <div className="sp-header-text">Special Programs</div>
              <img src={process.env.PUBLIC_URL + '/images/SAP/awesome-desktop.svg'} alt="" className="sp-header-icon" />
            </div>
            <div className="sp-body">
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  Special Programs 1
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  Special Programs 2
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
      {/* <div className="ql-other-link">
        Want to learn more about SAP? Request for training
      </div> */}
    </>
  );
};

export default QuickLinks;
